<div class="checklist-results-container">
  <div class="header">
    <div class="title-row">
      <button
        class="back-btn"
        type="button"
        [routerLink]="['/asset-management/compliance-library/compliance-details/assigned-assets/history']"
        [queryParams]="{
          assetId: assetId,
          complianceId: complianceId,
          assetName: assetName,
          complianceName: complianceName,
          complianceType: complianceType
        }"
        [attr.aria-label]="'compliance.library.checklistResults.backToHistory' | transloco">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M20.9999 11H6.41394L11.7069 5.70697L10.2929 4.29297L2.58594 12L10.2929 19.707L11.7069 18.293L6.41394 13H20.9999V11Z"
            fill="#9FA1A4" />
        </svg>
      </button>
      <h2 class="title m-0 h3">{{ assetName }}</h2>
    </div>
  </div>

  @if (showTabs && !isLoading && !hasError) {
    <div class="cmn_tabWrap">
      <div class="cmn_tabWrapUl">
        <ul class="nav nav-pills" id="phase-tab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link" [class.active]="activeTab === 'pre'"
              type="button" role="tab" [attr.aria-selected]="activeTab === 'pre'"
              (click)="toggleTab('pre')">
              {{ phaseTabTitles.pre }}
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" [class.active]="activeTab === 'post'"
              type="button" role="tab" [attr.aria-selected]="activeTab === 'post'"
              (click)="toggleTab('post')">
              {{ phaseTabTitles.post }}
            </button>
          </li>
        </ul>
      </div>
    </div>
  }

  @if (isLoading) {
    <div class="state-container">
      <span class="spinner-border"></span>
    </div>
  } @else if (hasError) {
    <div class="state-container">
      <app-error-state></app-error-state>
    </div>
  } @else if (hasNoResults) {
    <div class="state-container">
      <app-empty-state></app-empty-state>
    </div>
  } @else {
    <app-checklist-table
      [sections]="checklistSections"
      [groups]="checklistGroups"
      (actionClicked)="onActionClicked($event)">
    </app-checklist-table>

    @if (videosLoading || videos.length > 0) {
      <app-routine-video-cards
        [videos]="videos"
        [isLoading]="videosLoading"
        (videoClicked)="onVideoClick($event)">
      </app-routine-video-cards>
    }
  }
</div>